var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":_vm.height ? _vm.height : 5,"color":_vm.color ? _vm.color : 'blue darken-2'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }